import axios from "axios";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";

// components

export default function CardReport() {
  const [datas, setDatas] = useState({method: "products"});

  const handleData = (e) => {
    setDatas({ ...datas, [e.target.name]: e.target.value })

  }

  const handleDownload = () => {
    axios.post(`http://${process.env.REACT_APP_API_URL}/exports/excel`, datas, {
      headers: {
        Bearer: localStorage.getItem('token')
      },
      responseType: 'blob'
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${datas.method}.xlsx`);
      document.body.appendChild(link);
      link.click();

      link.remove();
    }).catch((error) => {
      if (error.response.data.status === 401) {
        window.location.href = "/auth/login";
      }
      console.log(error);
      // console.log(error.response.data.message);
    });
  }

  return (
    <>
      <div className="relative flex flex-col min-w-0 mt-10 mb-6 break-words border-0 rounded-lg shadow-lg bg-blueGray-100">
        <div className="px-6 py-6 mb-0 bg-white rounded-t">
          <div className="flex justify-between text-center">
            {/* <h6 className="text-xl font-bold text-blueGray-700">ReportSumUser</h6> */}
            <div className="flex">
              <div className="px-3 mb-3 md:mb-0" >
                <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                  หัวข้อReport
                </label>
                <select name="method" id="method" className="mr-2 rounded " onChange={handleData}>
                  <option value="products" selected>Products</option>
                  <option value="orders" >Orders</option>
                  <option value="ordersItems" >Orders Items</option>
                  <option value="ordersSumByUsers" >OrdersSumByUsers</option>
                  <option value="productsHistory" >Products History</option>
                </select>
              </div>
              {datas.method != "products"  && 
              <>
                <div className="px-3 mb-3 md:mb-0" >
                  <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                    จากวันที่
                  </label>
                  <input className="block px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                    id="fromDate" name="fromDate" type="date" max={datas.toDate} onChange={handleData} />
                </div>
                <div className="px-3 mb-3 md:mb-0" >
                  <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                    ถึงวันที่
                  </label>
                  <input className="block px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                    id="toDate" name="toDate" type="date" min={datas.fromDate} onChange={handleData} />
                </div>
              </>
              }
            </div>
            <button
              className="px-4 py-2 mr-1 text-xs font-bold text-white uppercase transition-all duration-150 ease-linear rounded shadow outline-none bg-lightBlue-500 active:bg-lightBlue-600 hover:shadow-md focus:outline-none"
              type="button"
              onClick={handleDownload}
              disabled={!datas.method}
              style={{ backgroundColor: !datas.method ? "#9CA3AF" : "#60A5FA" }}
            >
              Download
            </button>

            {/* <a href="/zix-backend/BE-zix-stock/report.xlsx" download>excel</a> */}
          </div>
        </div>

      </div>
    </>
  );
}
